import * as z from "zod";

export const categoryLimitFormSchema = z.object({
  amount: z
    .string()
    .min(1, "Enter a monthly limit")
    .refine((value) => Number.isFinite(Number(value)), {
      message: "Enter a valid amount",
    })
    .refine((value) => Number(value) >= 0, {
      message: "Limit can't be negative",
    })
    .refine((value) => Number(value) <= 99999999, {
      message: "That limit is too large",
    }),
});

export type CategoryLimitFormValues = z.infer<typeof categoryLimitFormSchema>;
